module.exports = __webpack_public_path__ + "img/CANVA.9062dda0.png";